module.exports = __webpack_public_path__ + "img/tasks_inactive.7d6ad99f.svg";